module.exports = __webpack_public_path__ + "img/first.9695d6db.png";